export const inspectTable = [
  {
    content: "특수형태근로종사자에 대한 안전조치 및 보건조치 등  (법 제77조)",
    isChecked: "",
  },
  {
    content: "배달종사자에 대한 안전조치 (법 제78조)",
    isChecked: "",
  },
  {
    content: "가맹본부의 산업재해 예방조치 (법 제79조)",
    isChecked: "",
  },
];
